import { FC } from "react";
import { TranslationService } from "../../services/TranslationService";
import CompanyService from "../../services/CompanyService";

export interface UserLimitModal {
  users: number;
  userLimit: number;
  userOwnerId: number;
  readonlyUserLimit: number;
  companiesLimit: number;
  personsLimit: number;
  persons: number;
  readonlyUsers: number;
}

const UserLimit: FC<UserLimitModal> = (data) => {
  const { translate } = TranslationService;
  return (
    <>
      {data.userOwnerId === parseInt(CompanyService.getUserid()) ? (
        <>
          <div className="row">
            <div className="col">
              <p> {translate.MainMessageLimitReacher} </p>
              <p> {translate.OrDelete} </p>
              <ul>
                {data.users >= data.userLimit && (
                  <li>
                    <p>
                      {" "}
                      {translate.InAllCompanies} {data.users} {translate.Users}{" "}
                      {translate.MaximumAllowed} {data.userLimit}{" "}
                    </p>
                  </li>
                )}

                {data.readonlyUserLimit > 0 &&
                  data.readonlyUsers >= data.readonlyUserLimit && (
                    <li>
                      <p>
                        {" "}
                        {translate.InAllCompanies} {data.readonlyUsers}{" "}
                        {translate.ReadonlyUsers} {translate.MaximumAllowed}{" "}
                        {data.readonlyUserLimit}{" "}
                      </p>
                    </li>
                  )}

                {data.persons >= data.personsLimit && (
                  <li>
                    <p>
                      {" "}
                      {translate.InAllCompanies} {data.persons}{" "}
                      {translate.UserCustomers} {translate.MaximumAllowed}{" "}
                      {data.personsLimit}{" "}
                    </p>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="row">
            <div className="col">
              <p> {translate.OwnerLimitReached} </p>
              <p>
                {translate.ToContinue} {translate.UpgradePlan}
              </p>
              <p> {translate.OrDelete} </p>
              <br />
              <p> {translate.ContactOwner} </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UserLimit;
